import React, { useCallback, useState } from 'react';

import { Box } from '@lyearn/ui';
import Department from '@/modules/corporate/modules/learners/views/LearnerManager/components/Invite/Learner/Dialog/components/ManualInvite/Editor/Department';
import DepartmentRole from '@/modules/corporate/modules/learners/views/LearnerManager/components/Invite/Learner/Dialog/components/ManualInvite/Editor/DepartmentRole';

import OrganizationRole from '../OrganizationRole';
import ReportingManager from '../ReportingManager';
import ChangeDepartmentDialog from './components/ChangeDepartmentDialog';
import { AdditionalDetailsProps } from './types';

function AdditionalDetails({ values, onChange, learner, errors }: AdditionalDetailsProps) {
  const [changeDepartmentDialog, setChangeDepartmentDialogState] = useState<{
    onRevert: VoidFunction;
  }>();

  const onChangeDepartment = useCallback(
    (value?: string | null) => {
      const currentDepartmentId = values.departmentId;
      onChange('department.set', value);

      if (currentDepartmentId && values.responsibilityIds?.length) {
        setChangeDepartmentDialogState({
          onRevert: () => {
            onChange('department.set', currentDepartmentId);
            setChangeDepartmentDialogState(undefined);
          },
        });
      }
    },
    [onChange, values.departmentId, values.responsibilityIds?.length],
  );

  return (
    <>
      <Box className="space-y-20">
        <Department departmentId={values.departmentId} onChange={onChangeDepartment} />
        <DepartmentRole
          departmentId={values.departmentId}
          error={errors.responsibilityIds}
          selectedRoleIds={values.responsibilityIds}
          onChange={(value) => onChange('responsibilityIds.add', value)}
        />
        <OrganizationRole
          orgRoleId={values.orgRoleId}
          user={learner}
          onChange={(value?: string) => onChange('orgRole.set', value)}
        />
        <ReportingManager
          error={errors.reportsToUserId}
          reportsToUserId={values.reportsToUserId}
          user={learner}
          onChange={(value?: string) => onChange('reportsToUserId', value)}
        />
      </Box>
      {changeDepartmentDialog ? (
        <ChangeDepartmentDialog
          onPrimaryAction={() => {
            onChange('responsibilityIds.add', []);
            setChangeDepartmentDialogState(undefined);
          }}
          onRevert={changeDepartmentDialog.onRevert}
        />
      ) : null}
    </>
  );
}

export default React.memo(AdditionalDetails);
